<template>
  <header>
    <div class="custom-header-element"></div>
    <div class="competition-name">Scramble Table</div>
    <div><button class="settings-button">Settings ⚙️</button></div>
  </header>
  <scramble-table-contents>
  </scramble-table-contents>
  <dialog class="scramble-table-settings">
    <button class="close">Close</button>
    <h1>Settings</h1>
    <hr>
    <span>Add encrypted scrambles to this device via JSON:</span>
    <br><input type="file" class="file-input" name="Add encrypted JSON"><br>
    <span class="input-feedback"></span><br>
    <span><button class="clear-json">Clear JSON</button></span>

    <hr>
    Number of scramble displays: <input class="num-scramble-displays" type="number" min="1" max="4" value="2">
  </dialog>
</template>
